import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import {
  DEFAULT_MAILBOXES_TO_ADD,
  FETCH_DATA,
  MAILBOXES_TO_ADD_COUNTER_CHANGE,
  SUBMIT_MAILBOX_UPDATE,
} from './constants'

export default function () {
  const initialState = {
    loader: false,
    error: null,
    data: {},
    mailboxesToAdd: DEFAULT_MAILBOXES_TO_ADD,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case COMPANY_FILTER_CHANGE:
      case SUBMIT_MAILBOX_UPDATE.INITIATE:
      case FETCH_DATA.INITIATE:
        return { ...state, loader: true, error: null }
      case FETCH_DATA.SUCCESS:
        return {
          ...state,
          error: null,
          data: action.payload.data,
          loader: false,
        }
      case FETCH_DATA.ERROR:
        return { ...state, error: action.error }
      case SUBMIT_MAILBOX_UPDATE.CANCEL:
      case FETCH_DATA.CANCEL:
        return { ...state, loader: false }
      case SUBMIT_MAILBOX_UPDATE.SUCCESS:
        return { ...state, error: null, loader: false }
      case MAILBOXES_TO_ADD_COUNTER_CHANGE:
        return { ...state, mailboxesToAdd: action.payload.value }
      default:
        return state
    }
  }
}
